import { mdiHandshake } from "@mdi/js";

const Nav = [
  {
    title: "Partenaires",
    icon: mdiHandshake,
    children: [
      {
        title: "Liste",
        to: "partners-list",
        resource: "all",
        action: "manage",
      },
      {
        title: "Editer",
        to: "partner-edit",
        resource: "all",
        action: "manage",
      },
      {
        title: "Vues de partenaires",
        resource: "partner-view",
        action: "read",
        children: [
          {
            title: "Liste",
            to: "partner-views-list",
            resource: "partner-view",
            action: "read",
          },
          {
            title: "Créer / éditer",
            to: "partner-view-edit",
            resource: "partner-view",
            action: "manage",
          },
        ],
      },
      {
        title: "Partner accounts",
        resource: "partner-account",
        action: "read",
        children: [
          {
            title: "Liste",
            to: "partner-accounts-list",
            resource: "partner-account",
            action: "read",
          },
          {
            title: "Créer / éditer",
            to: "partner-account-edit",
            resource: "partner-account",
            action: "manage",
          },
          {
            title: "Data",
            to: "partner-account-data",
            resource: "partner-account",
            action: "manage",
          },
        ],
      },
      {
        title: "Relations partenaires",
        resource: "all",
        action: "manage",
        children: [
          {
            title: "Liste",
            to: "partner-relations-list",
            resource: "all",
            action: "manage",
          },
          {
            title: "Créer / éditer",
            to: "partner-relation-edit",
            resource: "all",
            action: "manage",
          },
        ],
      },
      {
        title: "Groupes de vues de partenaires",
        resource: "admin",
        action: "manage",
        children: [
          {
            title: "Liste des groupes de vues de partenaires",
            to: "partner-view-groups-list",
            resource: "admin",
            action: "manage",
          },
          {
            title: "Créer/éditer un groupe de vues de partenaires",
            to: "partner-view-group-edit",
            resource: "admin",
            action: "manage",
          },
        ],
      },
    ],
  },
];

export default Nav;
